import IconsContainer from './IconsContainer';

export default IconsContainer;
